import { PlusCircle, PlusSquareIcon, X } from "lucide-react";
import React, { useState } from "react";

function AddFailedResponseModal({ onClose, onSubmit }) {
  const [value, setValue] = useState("");
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
      <div className="w-[520px] max-w-[95%] bg-white rounded-xl shadow-2xl border border-gray-200 p-6 flex flex-col gap-5">
        {/* Header */}
        <div className="flex items-center justify-between border-b pb-3">
          <div className="text-xl font-semibold text-blue-600 flex items-center gap-2">
            <PlusSquareIcon size={22} />
            Add Failed Response
          </div>

          <button
            onClick={onClose}
            className="text-gray-500 hover:text-black transition"
          >
            <X size={20} />
          </button>
        </div>

        {/* Textarea */}
        <div className="flex flex-col gap-2">
          <label className="text-sm font-medium text-gray-600">
            Response Data
          </label>

          <textarea
            onChange={(e) => setValue(e.target.value)}
            value={value}
            spellCheck="false"
            placeholder="Paste failed response JSON here..."
            className="w-full min-h-[220px] resize-none rounded-lg border border-gray-300 bg-gray-50 p-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
          />
        </div>

        {/* Footer Buttons */}
        <div className="flex justify-end gap-3 pt-3 border-t">
          <button
            onClick={onClose}
            className="px-5 py-2 rounded-md border border-gray-300 text-gray-600 hover:bg-gray-100 font-medium transition"
          >
            Cancel
          </button>

          <button
            onClick={() => {
              onSubmit(value);
              onClose();
            }}
            className="px-5 py-2 rounded-md bg-blue-600 hover:bg-blue-700 text-white font-medium flex items-center gap-2 shadow-sm transition"
          >
            <PlusCircle size={18} />
            Add Response
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddFailedResponseModal;
